import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles({
    emptyValue: {
        fontSize: pxToRem(14),
        color: '#bbb',
    },
    dateText: {
        fontSize: pxToRem(14),
        fontFamily: 'Roboto',
    },
})

interface LastScrapedCellProps {
    value: string | undefined
}

/**
 * Displays the most recent successful scrape date for the listing's firm, formatted as "Mon DD, YYYY".
 *
 * Used for column: updatedLastAiScrapeDate.
 */
const LastScrapedCell = ({ value }: LastScrapedCellProps) => {
    const classes = useStyles()

    if (!value) {
        return (
            <Typography className={classes.emptyValue}>
                {'—'}
            </Typography>
        )
    }

    const date = new Date(value)
    if (isNaN(date.getTime())) {
        return <Typography className={classes.emptyValue}>{'—'}</Typography>
    }

    const formatted = date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })

    return (
        <Typography className={classes.dateText}>{formatted}</Typography>
    )
}

export default LastScrapedCell
